import { useState } from "react";
import { Typography } from "antd";
import Link from "../../../components/custom/info/Link";

const { Text } = Typography;

const MessageAreaInfo = ({
    message,
    type = "info",
    id,
    icon = false,
    animated = true,
    closable = false,
    onClose = () => {},
}) => {
    const [isVisible, setIsVisible] = useState(true);

    const handleClose = () => {
        setIsVisible(false);
        onClose();
    };

    if (!isVisible) return null;

    return (
        <div className="d-flex justify-content-center h-auto overflow-hidden">
            <div
                key={id}
                className={`d-flex hs-border-5 hs-message-area-${type} ${animated ? "hs-slide-top" : ""} text-white hs-h-2-5-rem h-100 w-100`}
            >
                <div className="w-100 d-flex align-items-center justify-content-center p-2 h-100 gap-1">
                    {icon && (
                        <div className="me-md-1 my-auto">
                            <div className="d-flex justify-content-center">
                                <div className={`staticIconsSprite alert-type-${type}-icon`}></div>
                            </div>
                        </div>
                    )}
                    <div className="w-100">
                        <Text className={`my-auto hs-fw-400 hs-color-${type} hs-fs-13`}>{message}</Text>
                    </div>
                </div>
                {closable && (
                    <div className="d-flex justify-content-end align-items-center p-1 pe-3">
                        <div className="actionIconsSprite2 close-icon-white" onClick={handleClose}></div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MessageAreaInfo;

export const MESSAGE_AREA_INFO_ALERTS = {
    whatsapp_disconnect_warning: {
        getMessage: (appProperties = {}) => (
            <>
                Scheduled Maintenance: Please revoke and re-scan your WhatsApp QR to ensure uninterrupted service —{" "}
                <Link
                    baseUrl={"/settings/channels/personal_whatsapp?"}
                    textClasses="hs-color-alert hs-fw-550 hs-fs-12 text-decoration-underline"
                    appProperties={appProperties}
                >
                    Re-scan now
                </Link>
            </>
        ),
        type: "alert",
        closable: true,
        animated: false,
        icon: true,
    },
};
